import { render, staticRenderFns } from "./PriceTypeMonedas.vue?vue&type=template&id=56bf83fa&"
import script from "./PriceTypeMonedas.vue?vue&type=script&lang=js&"
export * from "./PriceTypeMonedas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports